module.exports = __webpack_public_path__ + "static1710991110236-0.0.5.6/img/background_bottom_b@2x.81e1ef92.png";